'use strict';

import { CONST } from 'app_vodafone_ziggo/util/util';
import { validateForm } from 'app_vodafone_ziggo/util/validation';

/**
 * @constant selector - The selector
 */
const selector = '.js-checkbox-sync';

/**
 * @private onChange
 * @param {InputEven} evt - The input event
 */
function onChange(evt) {
    const target = evt.target.getAttribute(CONST.attributes.target);
    document.querySelector(target).checked = evt.target.checked;
}

/**
 * @public addEvent
 */
function addEvent() {
    Array.from(document.querySelectorAll(selector)).forEach((input) => {
        input.addEventListener(CONST.events.input, onChange);
    });
}

/**
 * @public updateFieldWithAnswers
 * @param {HTMLElement} clickedButton - the clicked button
 * @description Update hidden input field with the latest version of this.givenAnswers object.
 *              This is used for the chat plugin.
 */
function updateFieldWithAnswers(clickedButton) {
    // Remove step pages/answers that are null;
    const filteredAnswers = Object.fromEntries(
        Object.entries(this.givenAnswers)
            .filter(([, value]) => value != null)
            .map(([key, value]) => {
                if (clickedButton.getAttribute(this.attributes.companyInfo.name) && key === this.currentStepId) {
                    // If we're in the "select a company step", return object with company details
                    return [
                        key,
                        {
                            id: clickedButton.getAttribute(this.attributes.companyInfo.id),
                            kvkNumber: clickedButton.getAttribute(this.attributes.companyInfo.kvk),
                            businessName: clickedButton.getAttribute(this.attributes.companyInfo.name),
                            address: clickedButton.getAttribute(this.attributes.companyInfo.address),
                            city: clickedButton.getAttribute(this.attributes.companyInfo.city)
                        }
                    ];
                }
                return [key, value];
            })
    );

    document.querySelector(this.selectors.allAnswersField).value = JSON.stringify(filteredAnswers);
}

/**
 * @public handleQuestionKeyUp
 * @param {event} event - The keyup event
 */
function handleQuestionKeyUp(event) {
    const inputField = event.target;
    const query = inputField.value;
    const regex = inputField.getAttribute(this.CONST.attributes.pattern);
    this.currentStepNextButton = this.currentStep.querySelector(this.selectors.button.next);

    validateForm(this.currentStep);

    if (query.length > 0) {
        // Remove any character that's not part of the regex if the inputField only accepts numbers
        if (regex && inputField.getAttribute('type') === 'tel') {
            // Created an non-number regex value based on the existing regex
            const invertedRegex = new RegExp(regex.replace('\\d', '\\D'));

            // Update the input field with the new value that perfectly matches the input's regex
            inputField.value = inputField.value.replace(invertedRegex, '');
        }
    }

    // In case of a "question" step
    if (this.currentStep.classList.contains(this.classes.stepQuestion)) {
        // If, after key up, after possible regex removal, the length is still > 0...
        // reset customValidity to nothing and show the "next button"
        if (inputField.value.length > 0) {
            inputField.setCustomValidity('');
        }
    }
}

/**
 * @public focusFirstInput
 * @description Auto select the first input for UX convenience sake,
 *              which also will auto popup the onscreen keyboard for devices that support that
 */
function focusFirstInput() {
    if (this.targetStep && this.targetStep.classList.contains(this.CONST.classes.active) && !this.targetStep.classList.contains(this.classes.introAnimation)) {
        const stepInput = this.targetStep.querySelector(this.CONST.selectors.form.input);

        if (stepInput) {
            stepInput.focus();
        }
    }
}

export { addEvent as syncCheckboxes, updateFieldWithAnswers, handleQuestionKeyUp, focusFirstInput };
